import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.24 6.035c-.447.146-.725.507-.729.945-.003.432-.08.342 2.343 2.77L13.099 12l-2.245 2.25c-2.423 2.428-2.346 2.338-2.343 2.77.007.707.758 1.185 1.389.884.159-.076.736-.634 2.846-2.75 2.837-2.847 2.743-2.739 2.743-3.154s.094-.307-2.743-3.153c-1.582-1.586-2.709-2.685-2.803-2.734-.171-.089-.544-.13-.703-.078" }, null, -1)
  ]))]))
}
export default { render: render }